<div>
  <div class="col-md-12 col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 row m-0 paddingbottom">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb breadcrumb-rightAlign" style="margin-bottom: 0px; padding: 1.5% 0px 0px 0px;">
        <li class="breadcrumb-item"><a class="breadcrumb-home" [routerLink]="['/landing-page']">Home</a></li>
        <li class="breadcrumb-item">
          <a class="breadcrumb-home" style="cursor: pointer;" (click)="navigateToCapitalDemand()">Capital Demand</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">UCMG List View</li>
        <div>
          <button
            [attr.Pixel-tracking]="true"
            [attr.Pixel-title]="'Documentation'"
            class="breacrum-info-button uitk-icon uitk-icon-info_hollow health md-icon for-media excelandinfo-Icon-font info-icon"
            matTooltipPosition="left"
            title="Info"
            (click)="showDoc()"
          ></button>
        </div>
      </ol>
    </nav>
  </div>

  <div class="row m-0 filter-section mb-2">
    <div class="table-search col-md-3 col-sm-12 col-lg-3 col-xl-3 col-xs-12 p-0 w-0">
      <mat-form-field class="data-filter cd-table-search" appearance="outline" style="padding: 0px;">
        <input
          [(ngModel)]="searchField"
          matInput
          type="text"
          class="capability-search"
          placeholder="Search UCMG ID/UCMG Name"
          (keyup)="searchDataSet()"
        />
        <img src="../../../../assets/images/searchicon.png" class="ucmg-search-img" />
      </mat-form-field>
    </div>
    <div class="ps-0 capital-demand-filter-block w-12-pl">
      <app-dropdown-with-search
        [Pixeltracking]="true"
        searchFlag="false"
        placeholder="Fiscal Year"
        showPlaceholder="true"
        isMultiSelect="false"
        [dropdownData]="yearList"
        [selected]="ucmgYear"
        (selectionChange)="onYearChange($event)"
      ></app-dropdown-with-search>
    </div>
    <div class="ps-0 capital-demand-filter-block w-12">
      <app-dropdown-with-search
        [Pixeltracking]="true"
        searchFlag="false"
        placeholder="Investment Status"
        showPlaceholder="true"
        isMultiSelect="true"
        [dropdownData]="statusList"
        [selected]="selectedStatusList"
        (selectionChange)="setSelectedValues($event)"
      ></app-dropdown-with-search>
    </div>
    @if (ucmgView === 'leaderView') {
    <div class="ps-0 capital-demand-filter-block w-16">
      <app-dropdown-with-search
        [Pixeltracking]="true"
        searchFlag="false"
        placeholder="Funding Segment"
        showPlaceholder="true"
        isMultiSelect="true"
        [dropdownData]="fundingSegmentList"
        [selected]="selectedFundingSegmentList"
        (selectionChange)="setSelectedValues($event)"
      ></app-dropdown-with-search>
    </div>
    }
    <div class="ps-0 capital-demand-filter-block w-14">
      <app-dropdown-with-search
        [Pixeltracking]="true"
        [placeholder]="portfolioManagerPlaceholder"
        searchFlag="true"
        isMultiSelect="true"
        [dropdownData]="portfolioManagerList"
        [selected]="selectedPortfolioManagerList"
        (selectionChange)="setSelectedValues($event)"
      ></app-dropdown-with-search>
    </div>
    <div class="ps-0 capital-demand-filter-block w-14">
      <app-dropdown-with-search
        [Pixeltracking]="true"
        [placeholder]="ucmgOwnerPlaceholder"
        searchFlag="true"
        isMultiSelect="true"
        [dropdownData]="ucmgOwnerList"
        [selected]="selectedUcmgOwnerList"
        (selectionChange)="setSelectedValues($event)"
      ></app-dropdown-with-search>
    </div>
  </div>

  <div class="details-card details-card-margin mb-2">
    <div class="card-structure optum-font">
      @if (ucmgView === 'segmentView') {
      <div class="top-card-header">{{ segmentName }}</div>
      } @if (ucmgView === 'leaderView') {
      <div class="top-card-header-leaders">
        @for (leader of leadersData; track leader; let i = $index) {
        <div class="flexRowContainer">
          <!-- Last element highlight -->
          @if (leader === leadersData[leadersData.length-1]) {
          <li [style.padding-left.px]="i * 34 + 10" class="hierarchy-leaders-li pt-2">
            <span class="circle m-0" [ngClass]="{ 'extra-margin': true }">L{{ i + 1 }}</span>
            {{ leader.Leader }}
          </li>
          } @if (leader !== leadersData[leadersData.length-1]) {
          <li class="optum-font-nobold hierarchy-leaders-li" [style.padding-left.px]="i * 20 + 10">
            <mat-icon class="pt-2">expand_more</mat-icon>
            <span class="circle m-0" [ngClass]="{ 'extra-margin': true }">L{{ i + 1 }}</span>
            {{ leader.Leader }}
          </li>
          }
        </div>
        }
      </div>
      }
      <div class="top-card-hlist">
        @if (ucmgView === 'segmentView') {
        <div class="top-card-hlist-items">
          <div class="hlist-titles optum-font" style="text-align: left;">Funding Owner</div>
          <div class="regular-text hlist-spacing me-3 owner-delegate-height" style="overflow: auto; min-width: 143px;">
            @if (fundingOwnerList?.length>0) {
            <table style=" overflow: auto; text-align: left;">
              <tbody>
                @for (fundingOwner of fundingOwnerList; track fundingOwner) {
                <tr>
                  <td class="text_ProperCase">{{ fundingOwner }}</td>
                </tr>
                }
              </tbody>
            </table>
            } @else {
            <p class="d-flex">No Mapping</p>
            }
          </div>
        </div>
        } @if (ucmgView === 'segmentView') {
        <div class="top-card-hlist-items">
          <div class="optum-font hlist-titles" style="text-align: left;">Funding Delegate</div>
          <div class="regular-text hlist-spacing me-3 owner-delegate-height" style="overflow: auto; min-width: 143px;">
            @if (fundingDelegateList?.length>0) {
            <table style=" overflow: auto; text-align: left;">
              <tbody>
                @for (fundingDelegate of fundingDelegateList; track fundingDelegate) {
                <tr>
                  <td class="text_ProperCase">{{ fundingDelegate }}</td>
                </tr>
                }
              </tbody>
            </table>
            } @else {
            <p class="d-flex">No Mapping</p>
            }
          </div>
        </div>
        }
        <div class="top-card-hlist-items">
          <div class="top-card-hlist-box">
            @if (ucmgView === 'segmentView') {
            <div class="top-card-hlist-pill-headers hlist-titles">Total OT Variance</div>
            } @if (ucmgView === 'leaderView') {
            <div class="top-card-hlist-pill-headers hlist-titles">Total Leader OT Variance</div>
            }
            <div
              class="pill-detail preferred"
              (click)="ucmgSelect('Blue')"
              [ngClass]="{ 'ucmg-status-detail-shadow preferred-border': checkUCMGSelected('Blue') }"
            >
              <span class="ucmg-total">{{ totalApps.blue }}</span>
              <span class="pill-moneyfield"> ${{ totalCurrency.blue | BillionsToBMillionsToMThousandsToK }}</span>
            </div>
          </div>
        </div>
        <div class="top-card-hlist-items">
          <div class="top-card-hlist-box">
            @if (ucmgView === 'segmentView') {
            <div class="top-card-hlist-pill-headers hlist-titles">Fully Aligned</div>
            } @if (ucmgView === 'leaderView') {
            <div class="top-card-hlist-pill-headers hlist-titles">Allocation Aligned</div>
            }
            <div
              class="pill-detail acceptable"
              (click)="ucmgSelect('Green')"
              [ngClass]="{ 'ucmg-status-detail-shadow acceptable-border': checkUCMGSelected('Green') }"
            >
              <span class="ucmg-total">{{ totalApps.green }}</span>
              <span class="pill-moneyfield"> ${{ totalCurrency.green | BillionsToBMillionsToMThousandsToK }}</span>
            </div>
          </div>
        </div>
        <div class="top-card-hlist-items">
          <div class="top-card-hlist-box">
            @if (ucmgView === 'segmentView') {
            <div class="top-card-hlist-pill-headers hlist-titles">Under Allocated</div>
            } @if (ucmgView === 'leaderView') {
            <div class="top-card-hlist-pill-headers hlist-titles">Allocation > Run Rate</div>
            }
            <div
              class="pill-detail discouraged"
              (click)="ucmgSelect('Yellow')"
              [ngClass]="{ 'ucmg-status-detail-shadow discouraged-border': checkUCMGSelected('Yellow') }"
            >
              <span class="ucmg-total">{{ totalApps.yellow }}</span>
              <span class="pill-moneyfield"> ${{ totalCurrency.yellow | BillionsToBMillionsToMThousandsToK }}</span>
            </div>
          </div>
        </div>
        <div class="top-card-hlist-items">
          <div class="top-card-hlist-box">
            @if (ucmgView === 'segmentView') {
            <div class="top-card-hlist-pill-headers hlist-titles">Over Allocated</div>
            } @if (ucmgView === 'leaderView') {
            <div class="top-card-hlist-pill-headers hlist-titles">Run Rate > Allocation</div>
            }
            <div
              class="pill-detail unacceptable"
              (click)="ucmgSelect('Red')"
              [ngClass]="{ 'ucmg-status-detail-shadow unacceptable-border': checkUCMGSelected('Red') }"
            >
              <span class="ucmg-total">{{ totalApps.red }}</span>
              <span class="pill-moneyfield"> ${{ totalCurrency.red | BillionsToBMillionsToMThousandsToK }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Filtering/Bottom Section (Menaga) -->
  <div style="margin-top: 0px !important;">
    <div class="stk-table-container ucmg-list-table">
      <div class="table-header white-bg m-0 p-2 row">
        <h6 class="m-0 col-2">UCMG View</h6>
        <div class="col-8 d-flex align-items-center">
          @if (ucmgView === 'segmentView') {
          <span class="pill-container ms-1">
            <div class="pill-header-one">Total Forecast</div>
            <div class="pill">${{ totals.totalACAP | BillionsToBMillionsToMThousandsToK }}</div>
          </span>
          } @if (ucmgView === 'segmentView') {
          <span class="pill-container ms-1">
            <div class="pill-header-two">Total OT Forecast</div>
            <div class="pill">${{ totals.totalOptumTechLabor | BillionsToBMillionsToMThousandsToK }}</div>
          </span>
          } @if (ucmgView === 'segmentView') {
          <span class="pill-container ms-1">
            <div class="pill-header-three">Total Leader OT Allocation</div>
            <div class="pill">${{ totals.totalLeaderOTAllocation | BillionsToBMillionsToMThousandsToK }}</div>
          </span>
          }
        </div>
        <div class="col-2 excel-document-sec">
          <div>
            <button
              [attr.Pixel-tracking]="true"
              [attr.Pixel-title]="'Documentation'"
              class="breacrum-info-button uitk-icon uitk-icon-info_hollow health md-icon for-media excelandinfo-Icon-font info-icon"
              matTooltipPosition="left"
              title="Info"
              (click)="showDocForTable()"
            ></button>
          </div>
          @if (dataSourceDetails && dataSourceDetails.data.length) {
          <div (click)="exportToCsv()" class="export-link ">
            <span
              title="Click to Download"
              class="uitk-icon uitk-icon-download md-icon excel_Download excelandinfo-Icon-font"
            ></span>
          </div>
          }
        </div>
      </div>
      @if (showLoader) {
      <div class="stk-table-loader segment-loader ">
        <app-loader> </app-loader>
      </div>
      } @if (tabledata.length>0 ) {
      <app-capital-maintenance-table
        [TABLE_CONFIG]="TABLE_CONFIG"
        [COLUMNS]="TABLE_COLUMNS"
        [expanded_columns]="TABLE_COLUMNS"
        (reloadData)="handleAppicationload()"
        [SORT_CONFIG]="sortConfig"
        [dataSource]="dataSourceDetails"
        [pageSize]="TABLE_CONFIG.pageSize"
        [pageIndex]="TABLE_CONFIG.pageIndex"
        [ucmgListTable]="ucmgListTable"
        (dataRefresh)="dataRefresh($event)"
        [currentTable]="currentTable"
        [ucmgView]="ucmgView"
        [leadersData]="leadersData"
        [segData]="segData"
        (filteredDataChange)="handleFilteredDataChange($event)"
      >
      </app-capital-maintenance-table>
      }
    </div>
  </div>
</div>
